import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSkycamNetwork = () => {
  const [stations, setStations] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);
  const [locating, setLocating] = useState(false);

  const load = useCallback(async (location) => {
    try {
      const params = location ? { lat: location.lat, lon: location.lon, limit: 500 } : { limit: 500 };
      const [list, network] = await Promise.all([
        axios.get(`${API}/skycams/network/stations`, { params }),
        axios.get(`${API}/skycams/network`),
      ]);
      setStations(list.data || []);
      setSummary(network.data);
    } catch (_) {}
    setLoading(false);
  }, []);

  useEffect(() => {
    load(null);
    const timer = setInterval(() => load(userLocation), 60000);
    return () => clearInterval(timer);
  }, [load, userLocation]);

  const locate = useCallback(() => {
    if (!navigator.geolocation) return;
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const point = { lat: position.coords.latitude, lon: position.coords.longitude };
        setUserLocation(point);
        load(point);
        setLocating(false);
      },
      () => setLocating(false),
      { timeout: 10000, maximumAge: 300000 },
    );
  }, [load]);

  return { stations, summary, loading, userLocation, locate, locating };
};

export const usePublishedSkycams = () => {
  const [cams, setCams] = useState([]);
  useEffect(() => {
    let cancel = false;
    const load = async () => {
      try {
        const response = await axios.get(`${API}/skycams?enabled=true`);
        if (!cancel) setCams(response.data || []);
      } catch (_) {}
    };
    load();
    const timer = setInterval(load, 60000);
    return () => { cancel = true; clearInterval(timer); };
  }, []);
  return cams;
};
